import { render, staticRenderFns } from "./projectImportantList.vue?vue&type=template&id=073befa4&scoped=true"
import script from "./projectImportantList.vue?vue&type=script&lang=js"
export * from "./projectImportantList.vue?vue&type=script&lang=js"
import style0 from "./projectImportantList.vue?vue&type=style&index=0&id=073befa4&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073befa4",
  null
  
)

export default component.exports